export default __webpack_public_path__ + "static/media/18.4f33bb68.png";